import { captureException } from "@sentry/react-native"
import React from "react"
import { Platform } from "react-native"

/**
 * Return true if the browser's tab is focused on our app
 */
export default function useIsScreenFocused() {
  const [isFocused, setIsFocused] = React.useState(true)

  /**
   * Register event callback
   */
  React.useEffect(() => {
    let handleChange: (() => void) | undefined
    if (Platform.OS === "web") {
      handleChange = () => {
        setIsFocused(document.visibilityState === "visible")
      }
      document.addEventListener("visibilitychange", handleChange)
    } else {
      const message = `useIsScreenFocused.web is not supported on ${Platform.OS}`

      captureException(new Error(message))
    }
    return () => {
      if (handleChange) {
        document.removeEventListener("visibilitychange", handleChange)
      }
    }
  }, [])

  return isFocused
}
